/* eslint-disable react/jsx-key */
import React from 'react';
import { Wrapper } from '../styled';
import { StyledLabel, LoadingWrapper, LoadingIcon } from '../Processing/styled';
import { useIntl } from 'react-intl';
import LoadingGif from 'Images/faraday_loadingbar.gif';

const Uploading = () => {
  const intl = useIntl();
  return (
    <Wrapper>
      <StyledLabel children={ intl.formatMessage({ id: 'uploadContext.status.uploading' }) } />
      <LoadingWrapper children={ <LoadingIcon src={ LoadingGif } /> } />
    </Wrapper>
  );
};

export default Uploading;
